const stringHelper = {
    capitalizeFirstLetter: (text: string) => {
        return (text.length > 0) ? text.charAt(0).toUpperCase() + text.substr(1).toLowerCase() : text;
    },
};

export default stringHelper;
